import styled from 'styled-components';

import { DescriptionText, ListItem, theme } from 'components';

export const StyledSizeText = styled(DescriptionText)`
  && {
    color: ${theme.gray8};
  }
`;

export const StyledTeamGroupItem = styled(ListItem)<{ $md: boolean }>`
  cursor: pointer;
  display: grid;
  width: 100%;
  grid-column-gap: 16px;
  ${({ $md }) => `
  grid-template-columns: ${$md ? 'auto 1fr auto' : '1fr auto'};
  align-items: ${$md ? 'center' : 'start'};
  /* Move size text to bottom on small screens */
  ${
    $md
      ? ''
      : `& > ${StyledSizeText} {
        order: 1
      }`
  }
  `}
`;

export const StyledTableCell = styled.div<{ $active?: boolean }>`
  ${({ $active }) => `
  opacity: ${$active ? 1 : 0.5};
  `}
`;
